// B7-4/5: 提现账户绑定页(USDT + 银行卡 polymorphic)
// pen frames: dogdisk-user.pen # SlxwM / i2QnN
import { useState } from 'react'
import { Spinner } from '@dogdisk/shared'
import { AppLayout } from '../../components/app-layout'
import { MobileScreen, TopBar } from '../../components/mobile-screen'
import {
  useBindPayoutAccount,
  useMyPayoutAccounts,
  useRemovePayoutAccount,
  type BindPayoutInput,
} from '../../_lib/b7-api'

export function PayoutAccountsPage() {
  const { data, isLoading } = useMyPayoutAccounts()
  const bind = useBindPayoutAccount()
  const remove = useRemovePayoutAccount()
  const [tab, setTab] = useState<'usdt' | 'bank'>('usdt')
  const [usdtAddr, setUsdtAddr] = useState('')
  const [bank, setBank] = useState({ bank_name: '', account_no: '', account_holder: '' })
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const onBind = async () => {
    setError(null)
    setBusy(true)
    try {
      const input: BindPayoutInput =
        tab === 'usdt' ? { type: 'usdt', address: usdtAddr.trim() } : { type: 'bank', ...bank }
      await bind.mutateAsync(input)
      setUsdtAddr('')
      setBank({ bank_name: '', account_no: '', account_holder: '' })
    } catch (e) {
      setError((e as Error).message || '绑定失败')
    } finally {
      setBusy(false)
    }
  }

  const onRemove = async (id: string) => {
    if (!confirm('确定删除此账户?')) return
    await remove.mutateAsync({ id })
  }

  return (
    <AppLayout>
      <MobileScreen>
        <TopBar title="提现账户" />
        <div className="space-y-4 p-4">
          <div className="rounded-lg border bg-white p-4">
            <h2 className="mb-3 text-base font-medium">绑定新账户</h2>
            <div className="mb-3 flex gap-2">
              <button
                onClick={() => setTab('usdt')}
                className={`flex-1 rounded py-2 text-sm ${tab === 'usdt' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}
              >
                USDT 地址
              </button>
              <button
                onClick={() => setTab('bank')}
                className={`flex-1 rounded py-2 text-sm ${tab === 'bank' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}
              >
                银行卡
              </button>
            </div>
            {tab === 'usdt' ? (
              <input
                value={usdtAddr}
                onChange={(e) => setUsdtAddr(e.target.value)}
                placeholder="TRC20 / ERC20 地址"
                className="w-full rounded border px-3 py-2 text-sm"
              />
            ) : (
              <div className="space-y-2">
                <input
                  value={bank.bank_name}
                  onChange={(e) => setBank({ ...bank, bank_name: e.target.value })}
                  placeholder="银行名称(如:工商银行)"
                  className="w-full rounded border px-3 py-2 text-sm"
                />
                <input
                  value={bank.account_no}
                  onChange={(e) => setBank({ ...bank, account_no: e.target.value })}
                  placeholder="卡号"
                  className="w-full rounded border px-3 py-2 text-sm"
                />
                <input
                  value={bank.account_holder}
                  onChange={(e) => setBank({ ...bank, account_holder: e.target.value })}
                  placeholder="开户人姓名"
                  className="w-full rounded border px-3 py-2 text-sm"
                />
              </div>
            )}
            {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
            <button
              onClick={onBind}
              disabled={busy}
              className="mt-3 w-full rounded bg-blue-600 py-2 text-sm text-white disabled:bg-gray-300"
            >
              {busy ? '处理中…' : '绑定'}
            </button>
          </div>

          <div className="rounded-lg border bg-white p-4">
            <h2 className="mb-3 text-base font-medium">已绑账户</h2>
            {isLoading ? (
              <Spinner />
            ) : (
              <ul className="divide-y">
                {(data?.accounts ?? []).map((a) => (
                  <li key={a.id} className="flex items-center justify-between py-2 text-sm">
                    <div>
                      <p className="font-medium">
                        {a.type === 'usdt' ? `USDT · ${a.address}` : `${a.bank_name} · ${a.account_no}`}
                      </p>
                      {a.type === 'bank' && (
                        <p className="text-xs text-gray-500">开户人:{a.account_holder}</p>
                      )}
                    </div>
                    <button onClick={() => onRemove(a.id)} className="text-xs text-red-500">
                      删除
                    </button>
                  </li>
                ))}
                {data?.accounts?.length === 0 && (
                  <li className="py-4 text-center text-sm text-gray-400">尚未绑定账户</li>
                )}
              </ul>
            )}
          </div>
        </div>
      </MobileScreen>
    </AppLayout>
  )
}
